module.exports = __webpack_public_path__ + "static/img/3_12_1.4de6b0eb.jpg";